import { status_filter } from "../../components/constant/constant";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Search from "../../components/form/Search";
import Button from "../../components/form/Button";
import Table from "../../components/elements/table/Table";
import { setTitle } from "../../helpers/MetaTag";
import { encodeId, handleFilterChange } from "../../helpers";
import DeleteModal from "../../components/common/DeleteModal";

import {
  scholarshipDelete,
  scholarshipList,
} from "../../services/scholarshipService";
import dayjs from "dayjs";
import ManageScholarshipModal from "../../components/sections/admin/scholarship/modals/ManageScholarshipModal";
import useFetch from "../../hooks/useFetch";
import { useDebounce } from "../../hooks/useDebounce";
import LimitSelect from "../../components/elements/LimitSelect";
import useMutation from "../../hooks/useMutation";
import { Link } from "react-router-dom";
import { useGetPermission } from "../../hooks/useGetPermission";

const ScholarshipApplication = () => {
  setTitle("Vpeters Admin | Scholarships");
  const { permission, status } = useGetPermission("scholarships");

  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: [
      "scholarship",
      filters,
      search,
      permission?.list,
      permission?.assignScholarship,
    ],
    fetchFunction: async () => {
      const res = await scholarshipList({
        ...filters,
        ...(search && { keyword: search }),
      });

      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return {
        ...res?.docs,
        data:
          permission?.assignScholarship?.length > 0
            ? res?.docs?.data?.filter((item) =>
                permission?.assignScholarship.includes(item?._id)
              )
            : res?.docs?.data,
      };
    },
    enabled: !!permission?.list && status === "ok",
  });

  const tableHeadData = [
    {
      _id: 1,
      name: " Application Title",
      align: "left",
      // isSort: true,
      // isFilter: false,
      // isFilterSearch: false,
      // onSort: (val) => {
      //   if (val === "DESC") {
      //     // setSort("-title");
      //   } else {
      //     // setSort("title");
      //   }
      // },
    },

    {
      _id: 2,
      name: "Open Date",
      align: "left",
      // isSort: true,
      // isFilter: false,
      // isFilterSearch: false,
      // onSort: (val) => {
      //   if (val === "DESC") {
      //     // setSort("-description");
      //   } else {
      //     // setSort("description");
      //   }
      // },
    },

    {
      _id: 3,
      name: "Recurring Open?",
      align: "left",
      // isSort: false,
      // isFilter: false,
      // isFilterSearch: false,
    },
    {
      _id: 4,
      name: "Close Date",
      align: "left",
      // isFilter: true,
      // isFilterSearch: false,
      // isSort: false,
    },
    {
      _id: 5,
      name: "Recurring Close?",
      align: "left",
      // isFilter: true,
      // isFilterSearch: false,
      // isSort: false,
    },
    {
      _id: 6,
      name: "Eligibility Quiz",
      align: "left",
      // isFilter: true,
      // isFilterSearch: false,
      // isSort: false,
    },
    {
      _id: 7,
      name: "Scholarship Amount",
      align: "left",
      // isFilter: true,
      // isFilterSearch: false,
      // isSort: false,
    },
    {
      _id: 8,
      name: "Admin Notes",
      align: "left",
      // isFilter: true,
      // isFilterSearch: false,
      // isSort: false,
    },
    {
      _id: 9,
      name: "Status",
      align: "left",
      // isFilter: true,
      // isFilterSearch: false,
      // isSort: false,
      filterData: status_filter,
      onFilter: (data) => {
        handleFilterChange(
          "status",
          data?.map((item) => item?.value),
          setFilters
        );
        setFilters((prev) => ({ ...prev, offset: 0, currentPage: 0 }));
      },
    },
    {
      _id: 10,
      name: "# of Submission",
      align: "left",
      // isFilter: true,
      // isFilterSearch: false,
      // isSort: false,
      filterData: status_filter,
      onFilter: (data) => {
        handleFilterChange(
          "status",
          data?.map((item) => item?.value),
          setFilters
        );
        setFilters((prev) => ({ ...prev, offset: 0, currentPage: 0 }));
      },
    },
    {
      _id: 11,
      name: "#  of Awarded",
      align: "left",
      // isFilter: false,
      isSort: false,
    },
    ...(permission?.edit || permission?.delete
      ? [
          {
            _id: 12,
            name: "Action",
            align: "left",
          },
        ]
      : []),
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.title || "-",
          isTooltip: false,
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.publishDate
            ? dayjs(item?.publishDate).format("DD MMM, YYYY")
            : "-",
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.recurringOpen ? "yes" : "no" || "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.publishEndDate
            ? dayjs(item?.publishEndDate).format("DD MMM, YYYY")
            : "-",
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.recurringClose ? "yes" : "no" || "-",
        },
        {
          _id: 6,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.quizeDetails?.title || "-",
        },
        {
          _id: 7,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: <span>{item?.scholarshipAmount}</span> || "-",
        },
        {
          _id: 8,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.notes || "-",
        },
        {
          _id: 9,
          type: "status",
          align: "left",
          cellClass: "!min-w-[100px]",
          statusLabel: item?.status === 1 ? "Published" : "Draft",
          statusType: item?.status === 1 ? "success" : "danger",
        },
        {
          _id: 10,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            (
              <div className="flex items-center gap-2 text-chestnut-rose">
                {item?.maxNumberOfRecipient}
                <Link
                  to={`/admin/scholarship-application/list/${btoa(
                    encodeId(item?._id)
                  )}`}
                >
                  View
                </Link>
              </div>
            ) || "-",
        },
        {
          _id: 11,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: "-",
        },
        ...(permission?.edit || permission?.delete
          ? [
              {
                _id: 12,
                type: "action",
                align: "left",
                cellClass: "w-[5%]",
                actionData: [
                  ...(permission?.edit && status === "ok"
                    ? [
                        {
                          _id: 1,
                          name: "Edit",
                          icon: "fa-regular fa-pen-to-square",
                          onClick: () => {
                            setModalOpen({ isOpen: true, data: item });
                          },
                          standout: false,
                        },
                      ]
                    : []),
                  ...(permission?.delete && status === "ok"
                    ? [
                        {
                          _id: 2,
                          name: "Delete",
                          icon: "fa-regular fa-trash-can",
                          standout: true,
                          onClick: () => {
                            setDeleteModal({
                              isOpen: true,
                              data: item,
                            });
                          },
                        },
                      ]
                    : []),
                ],
              },
            ]
          : []),
      ],
    };
  });

  function scholarshipAddResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        updateData((pre) => ({
          ...pre,
          data: [res?.data, ...(pre?.data || [])],
        }));
      }
      if (res?.status === 200) {
        updateData((pre) => ({
          ...pre,
          data: pre?.data?.map((item) =>
            item?._id === res?.data?._id ? res?.data : item
          ),
        }));
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message || res?.error);
    }
  }

  //   scholarship delete handler =================>
  const { mutate: deletefunction, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await scholarshipDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return {
        res,
        payload: Array.isArray(payload) ? payload : [payload],
      };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        updateData((pre) => {
          pre.data = (pre?.data || [])?.filter(
            (item) => !payload?.includes(item?._id)
          );
          return { ...pre };
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          refetch();
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
          Scholarship List
        </div>
        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 1, setFilters);
              }}
              iconPosition={"right"}
            />
          </div>
          {permission?.add && status === "ok" && (
            <div className="relative">
              <Button
                buttonClasses={
                  "!bg-transparent border border-transparent !h-10 hover:!bg-chestnut-rose/10 hover:!border-chestnut-rose/10"
                }
                buttonLabel={"Create New"}
                buttonLabelClasses={"font-medium !text-sm text-chestnut-rose"}
                buttonFunction={() =>
                  setModalOpen({ isOpen: true, data: null })
                }
              />
            </div>
          )}
        </div>
      </div>
      {status === "ok" &&
        (permission?.list ? (
          <Table
            tableHeadData={tableHeadData}
            tableData={tableData}
            isLoder={isLoading}
            pageCount={data?.metadata?.totalPages}
            currentPage={filters?.page}
            onPageChange={(val) => {
              handleFilterChange("page", val, setFilters);
              setSelectedItems([]);
            }}
            isFetching={isFetching}
            isOrderingDisabled={true}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            tableActionDropdownContainer={"!w-48"}
          />
        ) : (
          <div className="font-semibold text-xl text-center h-60 flex items-center justify-center text-shades-07">
            You don't have permission to view this list.
          </div>
        ))}
      <ManageScholarshipModal
        open={modalOpen?.isOpen}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={scholarshipAddResponse}
        data={modalOpen?.data}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ ...pre, isOpen: false }))}
        deleteHandler={() => deletefunction([deleteModal?.data?._id])}
      />
    </div>
  );
};

export default ScholarshipApplication;
